module.exports = __webpack_public_path__ + "img/heads.9823d60c.svg";